export default function ProjectHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3e1f8630addb2f1d60cc3d5ba24d4ef4.jpg"
          alt="廃校活用プロジェクト"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/95 backdrop-blur-sm mb-8">
          <i className="ri-building-line text-[#2D7A3E] text-lg mr-2"></i>
          <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">廃校活用プロジェクト</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
          使われなくなった学校を<br />
          新しい産業拠点へ
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed">
          地域の課題である廃校を、持続可能な養殖産業の拠点として再生。<br />
          雇用を生み出し、地域経済を活性化させる新しい取り組みです。
        </p>

        <div className="flex flex-wrap justify-center gap-6">
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl">
            <p className="text-4xl font-bold text-[#2D7A3E] mb-1">100+</p>
            <p className="text-sm text-gray-700 whitespace-nowrap">雇用創出目標</p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl">
            <p className="text-4xl font-bold text-[#2D7A3E] mb-1">90%</p>
            <p className="text-sm text-gray-700 whitespace-nowrap">水使用量削減</p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl">
            <p className="text-4xl font-bold text-[#2D7A3E] mb-1">Zero</p>
            <p className="text-sm text-gray-700 whitespace-nowrap">環境排水</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}